import React from 'react';
import { BriefSectionView } from '../BriefSectionView';
import { briefClosing, briefSections, briefSubtitle } from '../../../data/brief';

/** Portrait print layout of the concept & strategy document. */
export function ConceptPdf() {
  return <div className="px-14" data-id="element-631" data-mp="2ardrr9n4q8za">
      <header data-pdf-block data-id="element-632" data-mp="25t2hwywu3yh2">
        <span className="font-body text-[10px] uppercase tracking-[0.24em] text-[rgba(1,51,43,0.45)]" data-id="element-633" data-mp="25ssspdjm5vcf">
          Concept &amp; strategy
        </span>
        <h1 className="mt-3 font-heading text-[52px] leading-[0.96] tracking-[-0.03em] text-background" data-id="element-634" data-mp="1i5kq53dkl0e3">
          Meet the Filteks
        </h1>
        <p className="mt-5 max-w-[28ch] font-heading text-[21px] leading-[1.25] tracking-[-0.01em] text-[rgba(1,51,43,0.6)]" data-id="element-635" data-mp="1s1xq2izpkaha">
          {briefSubtitle}
        </p>
      </header>

      <div className="mt-14 space-y-14" data-id="element-636" data-mp="33gks8e6598n6">
        {briefSections.map((section, i) => <BriefSectionView key={section.id} section={section} index={i} data-id="element-637" data-mp="2yhq8na0crg20" data-mpi={i} />)}
      </div>

      <section data-pdf-block className="mt-14 border-t border-[rgba(1,51,43,0.14)] pt-10" data-id="element-638" data-mp="19z0yhdynutai">
        <p className="max-w-[24ch] font-heading text-[32px] leading-[1.06] tracking-[-0.02em] text-background" data-id="element-639" data-mp="1a1eoh8ehhfb7">
          {briefClosing.statement}
        </p>
        <p className="mt-4 font-heading text-[21px] leading-tight text-[rgba(1,51,43,0.55)]" data-id="element-640" data-mp="1jyjexkfd3wxt">
          {briefClosing.support}
        </p>
      </section>

      <footer data-pdf-block className="mt-14 border-t border-[rgba(1,51,43,0.12)] pt-8" data-id="element-641" data-mp="r8syh4q9ciyj">
        <p className="font-body text-[12px] leading-relaxed text-[rgba(1,51,43,0.55)]" data-id="element-642" data-mp="w7nha6o867in">
          Original concept &amp; creative direction by Snakker™
        </p>
      </footer>
    </div>;
}